import React from "react";

//package import

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  DialogTitle,
} from "@mui/material";

//component

const DelModal = ({ status,status2, open, handleClose, provinceDelHandler  ,usersModal,  provinceDelHandler2,
}) => {
  //hooks

  // render

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={false}
      sx={{
        color: "gray",
        borderRadius: 2,
      }}
    >
      <DialogTitle>{}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ textAlign: "center" }}>
        {usersModal !== "users_modal" ? (
          <DialogContentText sx={{ textAlign: "center" }}>
            Are you sure you want to {status ? " active " : " inactive "}
            {status ? "the POU (Point of Use ) ?" : "the POU ( Point of Use ) ? "}
          </DialogContentText>
        ) : null}

        {usersModal === "users_modal" ? (
          <DialogContentText sx={{ textAlign: "center" }}>
            Are you sure you want to {status2 ? "active" : "inactive"}
            {status2 ? " the POU (Point of Use ) for User ?" : " the POU (Point of Use ) for User ?"}
          </DialogContentText>
        ) : null}
          {/* Are you sure you want to {status ? "active" : "inactive"} the POU (
          Point of Use )? */}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ marginTop: 5, margin: "auto" }}>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{ borderRadius: 2 }}
        >
          No
        </Button>

        <Button
          variant="contained"
          // onClick={provinceDelHandler}
          onClick={
            usersModal === "users_modal"
              ? provinceDelHandler2
              : provinceDelHandler
          }
          sx={{
            backgroundColor: "gray",
            borderRadius: 2,
          }}
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DelModal;
